import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export const Layout = ({ children }) => (
  <div className="grain min-h-screen bg-ink-900 relative">
    <Navbar />
    <main className="relative z-10">{children}</main>
    <Footer />
  </div>
);

export default Layout;
